import { InsuranceUsage } from './ClaimData'

export const enum InsuranceMemberStep {
  INIT = 'INIT',
  FIND_MEMBER = 'FIND_MEMBER',
  APPLY_INSURANCE = 'APPLY_INSURANCE',
  MEMBER_FOUND = 'MEMBER_FOUND',
  RESTRICTED = 'RESTRICTED',
  UNKNOWN = 'UNKNOWN',
}

export type InsuranceMemberStepPayload = {
  step: InsuranceMemberStep
}

export type InsuranceMemberStepState = InsuranceMemberStepPayload

export type ChangeInsuranceStatusRequest = {
  claimRecordId: string
  useInsuranceStatus: InsuranceUsage
}
